// A MEGSZÓLÍTÁS közös szabálya (user-döntés): ha a személynek van BECENEVE, azzal szólítjuk meg, különben a TELJES
// keresztnevével (több keresztnévnél az egészet — „Andrea Vivien" —, nem vágjuk le az első szót: arra a becenév
// való). EGY helyen él, hogy a kezdőlap köszöntése, a portál köszöntése és minden e-mail megszólítása ugyanazt
// mondja. A teljes nevet mutató helyek (listák, chipek, menü) NEM ezt használják — azok a `formatName`-et.
/** A megszólítási név: a becenév, különben a keresztnév (üres/csupa-szóköz érték nem számít); egyik sincs → `null`. */
export function addressName(person) {
    const nickname = person.nickname?.trim() ?? '';
    if (nickname !== '')
        return nickname;
    const givenName = person.givenName?.trim() ?? '';
    return givenName === '' ? null : givenName;
}
//# sourceMappingURL=person-address.js.map